import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref, watch } from 'vue';
import { isMobile } from '@/utils/';
import { useRouter, useRoute } from 'vue-router';
import pcNav from './modules/pcNav';
import openNav from './modules/openNav';
import mobileNav from './modules/mobileNav';
import logo from '@/assets/img/logo.svg';
import logoW from '@/assets/img/logo_w.svg';
export default {
  __name: 'index',
  setup(__props) {
    const _isMobile = isMobile();
    const selector = _isMobile ? '.header-m' : '.header';
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let dom;
      if (dom = document.querySelector(selector)) {
        // console.log('scrollTop', scrollTop);
        dom.style.background = `rgba(255, 255, 255, ${scrollTop ? '1' : '.1'})`;
      }
    };

    // 检测入口, 调整对应样式
    const logoImg = ref('');
    const navType = ref('normal');
    const isNote = ref(false);
    const router = useRouter();
    let style;
    watch(() => router.currentRoute.value.path, toPath => {
      console.log('toPath', toPath);
      if (toPath.includes('open')) {
        navType.value = 'open';
      } else if (toPath.includes('demo')) {
        navType.value = 'demo';
      } else {
        navType.value = 'normal';
      }
      style = router.currentRoute.value.meta.style || '';
      let dom;
      if ((dom = document.querySelector(selector)) && !_isMobile) {
        dom.setAttribute('style', style);
        isNote.value = toPath.includes('note') || toPath.includes('eSign');
        // let arrowStyle;
        // arrowStyle = router.currentRoute.value.meta.arrowStyle || '';
        // document.querySelector('.arrow-icon').setAttribute('style', arrowStyle);
      }

      logoImg.value = logo;
      if (style && !_isMobile) {
        window.onscroll = null;
        logoImg.value = logoW;
        return;
      }
      window.onscroll = handleScroll;
      handleScroll();
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      return !_unref(isMobile)() ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [navType.value === 'normal' ? (_openBlock(), _createBlock(_unref(pcNav), {
        key: 0,
        logoUrl: logoImg.value,
        class: _normalizeClass({
          'head-note': isNote.value
        })
      }, null, 8, ["logoUrl", "class"])) : navType.value === 'open' ? (_openBlock(), _createBlock(_unref(openNav), {
        key: 1
      })) : _createCommentVNode("", true)], 64)) : _unref(isMobile)() && navType.value !== 'demo' ? (_openBlock(), _createBlock(_unref(mobileNav), {
        key: 1
      })) : _createCommentVNode("", true);
    };
  }
};